import api from '@/api/fleet'
import { errorHandler } from "../exports/error_management"

const state = {
    vehicle: null,
    drivers: [],
    warehouses: [],
    items: [],
    pagination: null,
}

const mutations = {
    set(state, payload) {
        state.items = payload
    },
    delete(state, id) {
        let index = state.items.findIndex(x => x.id == id)
        state.items.splice(index, 1)
    },
    set_pagination(state, pag) {
        state.pagination = pag
    },
    set_vehicle(state, vehicle) {
        state.vehicle = vehicle
    },
    set_drivers(state, drivers) {
        state.drivers = drivers
    },
    set_warehouses(state, warehouses) {
        state.warehouses = warehouses
    },
}

const actions = {
    create(context, payload) {
        return api
            .create(payload)
            .then(() => {})
            .catch(err => {
                errorHandler(err)
            })
    },
    fetchById(context, id) {
        return api
            .fetchById(id)
            .then(
                ({
                    data: {
                        success: { data: vehicle },
                    },
                }) => {
                    console.log('store vehecddddd', vehicle)
                    context.commit('set_vehicle', vehicle)
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },
    fetchDrivers(context) {
        //const driver_role_id = 2
        return api
            .fetchDrivers()
            .then(
                ({
                    data: {
                        success: {
                            data: { data: drivers },
                        },
                    },
                }) => {
                    /*  console.log('drivers', drivers)
                    drivers = drivers.filter(
                        x => !!x.roles.find(r => r.role_id == driver_role_id)
                    ) */
                    context.commit('set_drivers', drivers)
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },

    fetch(context, payload) {
        return api
            .fetch(payload.query, payload.page)
            .then(
                ({
                    data: {
                        success: { data: pag },
                    },
                }) => {
                    console.log('pag', pag)
                    let users = pag.data

                    context.commit('set', users)
                        //let pag = result.data.success.data
                    context.commit('set_pagination', {
                        page: pag.current_page,
                        pageSize: pag.per_page,
                        total: pag.total,
                    })
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },

    update(context, payload) {
        console.log('update', payload)
        return api
            .update(payload.id, payload)
            .then(() => {})
            .catch(err => {
                errorHandler(err)
            })
    },
    delete(context, id) {
        return api
            .delete(id)
            .then(() => {
                context.commit('delete', id)
            })
            .catch(err => {
                errorHandler(err)
            })
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}